<template>
    <el-dialog :title="title" top="8%" width="30%" :before-close="handleClose" :visible.sync="dialogVisible"
        :close-on-click-modal="false" :custom-class="'performanceCreationDialog'">
        <el-form :model="formData" :rules="rules" ref="form" label-width="135px">
            <el-row>
                <el-col>
                    <el-form-item label="配置类型：" prop="riskType">
                        <otpSelect :optionNum="'OTP_RISK_TYPE'" @getSelectValue="getConfigValue"
                            :mValue="formData.riskType" placeholder="请选择配置类型" :prop="'riskType'" :disabled="!!rowData.id">
                        </otpSelect>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="参数类型：" prop="riskReason">
                        <otpSelect :optionNum="'OTP_RISK_REASON'" @getSelectValue="getSelectValue"
                            :mValue="formData.riskReason" placeholder="请选择参数类型" :prop="'riskReason'" :disabled="true">
                        </otpSelect>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="风控维度：" prop="riskLevel">
                        <otpSelect :optionNum="'OTP_RISK_LEVEL'" @getSelectValue="getSelectValue"
                            :mValue="formData.riskLevel" placeholder="请选择风控维度" :prop="'riskLevel'" :disabled="true">
                        </otpSelect>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="是否推送BMS强控：" prop="forceFlag">
                        <el-select v-model="formData.forceFlag" placeholder="请选择是否推送BMS强控" :disabled="['2103', '2104'].includes(formData.riskType)">
                            <el-option label="是" value="true"></el-option>
                            <el-option label="否" value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item label="备注：" prop="remark">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 5 }"
                            maxlength="200"
                            placeholder="请输入备注"
                            v-model="formData.remark">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit">保 存</el-button>
        </div>

    </el-dialog>
</template>
<script>
import otpSelect from '@/components/lots/otpSelect';
import { addConfig, updateConfig } from '@otp/api/riskControlConfig.js';
export default {
    name: 'performanceCreationDialog',
    components: { otpSelect },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '新增配置'
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            formData: {
                id: '',
                riskType: '',
                riskReason: '',
                riskLevel: '',
                forceFlag: '',
                remark: ''
            },
            rules: {
                riskType: [{ required: true, message: '配置类型不能为空', trigger: ['change', 'blur'] }],
                riskReason: [{ required: true, message: '参数类型不能为空', trigger: ['change', 'blur'] }],
                riskLevel: [{ required: true, message: '风控维度不能为空', trigger: ['change', 'blur'] }],
                forceFlag: [{ required: true, message: '是否推送BMS强控不能为空', trigger: ['change', 'blur'] }]
            }
        };
    },
    mounted () {
        this.rowData && this.rowData.id && this.initDialogInfo(this.rowData);
    },
    methods: {
        initDialogInfo (row) {
            const { id, riskType, riskReason, riskLevel, remark, forceFlag } = row;
            this.formData = {
                id,
                riskType,
                riskReason,
                riskLevel,
                forceFlag,
                remark
            };
        },
        /**
       * @description 下拉框选择后回调
       * @param {Object} data 选中的数据
       */
        getSelectValue (data) {
            Object.keys(data).forEach(k => {
                this.formData[k] = data[k] || '';
            });
        },
        getConfigValue (data) {
            this.formData.riskType = data.riskType || '';
            if (data.riskType === '2101') {
                this.formData.riskReason = '21010';
                this.formData.riskLevel = '10';
            }
            if (data.riskType === '2102') {
                this.formData.riskReason = '21020';
                this.formData.riskLevel = '20';
            }
            if (data.riskType === '2103') {
                this.formData.riskReason = '21030';
                this.formData.riskLevel = '20';
                this.formData.forceFlag = 'false';
            }
            if (data.riskType === '2104') {
                this.formData.riskReason = '21040';
                this.formData.riskLevel = '20';
                this.formData.forceFlag = 'false';
            }
            if (data.riskType === '3101') {
                this.formData.riskReason = '31010';
                this.formData.riskLevel = '20';
            }
            if (data.riskType === '3103') {
                this.formData.riskReason = '31030';
                this.formData.riskLevel = '20';
            }
            if (data.riskType === '3104') {
                this.formData.riskReason = '31040';
                this.formData.riskLevel = '20';
            }
            if (data.riskType === '3105') {
                this.formData.riskReason = '31050';
                this.formData.riskLevel = '20';
            }
        },
        // 关闭弹窗
        handleClose () {
            this.$emit('handleClose');
        },
        // 提交
        handleSubmit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const param = { ...this.formData };
                    if (param.forceFlag === 'true') {
                        param.forceFlag = true;
                    } else if (param.forceFlag === 'false') {
                        param.forceFlag = false;
                    } else {
                        param.forceFlag = '';
                    }
                    this.dispatchSubmit(param).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('操作成功');
                            this.$emit('handleSuccess');
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        dispatchSubmit (params) {
            return this.formData.id ? updateConfig(params) : addConfig(params);
        }
    }
};
</script>
<style lang="less">
.performanceCreationDialog {
    .el-dialog__body {
        padding: 30px 50px 10px 0;
    }

    .el-form-item__content .el-input-group {
        vertical-align: middle;
    }
}

.el-select {
    width: 100%;
}
</style>
